import { motion } from "framer-motion";

export const Section = ({ id, index, title, children, className = "" }) => (
  <section
    id={id}
    data-testid={`section-${id}`}
    className={`relative border-t border-white/10 px-6 py-24 md:px-12 md:py-32 lg:px-20 ${className}`}
  >
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="mb-16 flex items-baseline gap-6 md:mb-20">
        <span className="font-mono text-sm tracking-[0.3em] text-cyan-400">[{index}]</span>
        <h2 className="font-display text-3xl font-black uppercase tracking-tighter text-white md:text-5xl">
          {title}
        </h2>
        <div className="hidden h-px flex-1 bg-white/10 md:block" />
        <span className="hidden font-mono text-xs uppercase tracking-[0.25em] text-zinc-600 md:block">
          karansahu.pro
        </span>
      </div>
      {children}
    </motion.div>
  </section>
);
